import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

const LOAD_LOCATIONS = 'LOAD_LOCATIONS'

export default namespaceActions(NAME)([LOAD_LOCATIONS])
